import { LAppDefine, ModelPaths, NpcModel } from "./LAppDefine";
import { LAppModel } from "./LAppModel";
import { Live2D } from "./live2d";
import { Live2DFramework } from "./Live2DFramework";
import { PlatformManager } from "./PlatformManager";

export class LAppLive2DManager {
  // console.log("--> LAppLive2DManager()");

  // モデルデータ
  models: LAppModel[] = []; // LAppModel

  //  サンプル機能
  reloadFlg = false; // モデル再読み込みのフラグ
  constructor(private resourceRootPath: string, private gl: WebGLRenderingContext) {
    Live2D.init();
    Live2DFramework.setPlatformManager(new PlatformManager(gl));
  }

  createModel(): LAppModel {
    // console.log("--> LAppLive2DManager.createModel()");

    var model = new LAppModel();
    this.models.push(model);

    return model;
  }

  changeModel(model: NpcModel) {
    // console.log("--> LAppLive2DManager.update(gl)");
    if (this.reloadFlg) {
      // モデル切り替えボタンが押された時、モデルを再読み込みする
      this.reloadFlg = false;
      const modelPaths = ModelPaths[model];
      this.showModels(modelPaths);
    }
  }

  showModels(modelPaths: string[], i: number = 0) {
    let model = this.getModel(i);
    if (!model) {
      model = this.createModel();
    }
    model.load(this.gl, `${this.resourceRootPath}${modelPaths[i]}`, () => {
      if (i < modelPaths.length - 1) {
        this.showModels(modelPaths, i + 1);
      }
    });
  }

  getModel(no) {
    // console.log("--> LAppLive2DManager.getModel(" + no + ")");

    if (no >= this.models.length) return null;

    return this.models[no];
  }

  /*
   * モデルを解放する
   * ないときはなにもしない
   */
  releaseModel(no, gl) {
    // console.log("--> LAppLive2DManager.releaseModel(" + no + ")");

    if (this.models.length <= no) return;

    this.models[no].release(gl);

    delete this.models[no];
    this.models.splice(no, 1);
  }

  /*
   * モデルの数
   */
  numModels() {
    return this.models.length;
  }

  /*
   * ドラッグしたとき、その方向を向く設定する
   */
  setDrag(x, y) {
    for (var i = 0; i < this.models.length; i++) {
      this.models[i].setDrag(x, y);
    }
  }

  /*
   * 画面が最大になったときのイベント
   */
  maxScaleEvent() {
    if (LAppDefine.DEBUG_LOG) console.log("Max scale event.");
    for (var i = 0; i < this.models.length; i++) {
      this.models[i].startRandomMotion(LAppDefine.MOTION_GROUP_PINCH_IN, LAppDefine.PRIORITY_NORMAL);
    }
  }

  /*
   * 画面が最小になったときのイベント
   */
  minScaleEvent() {
    if (LAppDefine.DEBUG_LOG) console.log("Min scale event.");
    for (var i = 0; i < this.models.length; i++) {
      this.models[i].startRandomMotion(LAppDefine.MOTION_GROUP_PINCH_OUT, LAppDefine.PRIORITY_NORMAL);
    }
  }

  /*
   * タップしたときのイベント
   */
  tapEvent(x, y) {
    if (LAppDefine.DEBUG_LOG) console.log("tapEvent view x:" + x + " y:" + y);

    for (var i = 0; i < this.models.length; i++) {
      if (this.models[i].hitTest(LAppDefine.HIT_AREA_HEAD, x, y)) {
        // 顔をタップしたら表情切り替え
        if (LAppDefine.DEBUG_LOG) console.log("Tap face.");

        this.models[i].setRandomExpression();
      } else if (this.models[i].hitTest(LAppDefine.HIT_AREA_BODY, x, y)) {
        // 体をタップしたらモーション
        if (LAppDefine.DEBUG_LOG) console.log("Tap body." + " models[" + i + "]");

        this.models[i].startRandomMotion(LAppDefine.MOTION_GROUP_TAP_BODY, LAppDefine.PRIORITY_NORMAL);
      }
    }

    return true;
  }

  talkEvent() {
    this.models.forEach((model) => model.startRandomMotion(LAppDefine.MOTION_GROUP_TALK, LAppDefine.PRIORITY_NORMAL));
  }
}
